import { announcementsApiRef } from '@backstage-community/plugin-announcements-react';
import { AnnouncementsList } from '@backstage-community/plugin-announcements-common';
import { errorApiRef, useApi } from '@backstage/core-plugin-api';
import { useCallback, useEffect, useState } from 'react';

export interface NewsUpdate {
  id: string;
  title: string;
  created_at: string;
  category?: string;
  body: string;
}

export const useNewsUpdates = (max = 4) => {
  const newsApi = useApi(announcementsApiRef);
  const errorApi = useApi(errorApiRef);
  const [isLoading, setIsLoading] = useState(true);
  const [newsUpdates, setNewsUpdates] = useState<NewsUpdate[]>([]);
  const [error, setError] = useState<Error | null>(null);

  const fetchNewsUpdates = useCallback(async () => {
    setIsLoading(true);
    try {
      const output: AnnouncementsList = await newsApi.announcements({ max });
      if (Array.isArray(output.results)) {
        setNewsUpdates(
          output.results.map((item: any) => ({
            id: item.id,
            title: item.title,
            created_at: item.created_at,
            category: item.category?.title,
            body: item.body,
          })),
        );
      } else {
        throw new Error('Unexpected response format.');
      }
    } catch (e) {
      const errorObject = new Error('Failed to fetch news and updates.');
      errorApi.post(errorObject);
      setError(errorObject);
    } finally {
      setIsLoading(false);
    }
  }, [newsApi, errorApi, max]);

  useEffect(() => {
    fetchNewsUpdates();
  }, [fetchNewsUpdates]);

  return { isLoading, newsUpdates, error };
};
